import { devices, sizes } from "library/constants";
import styled from "styled-components";

import { ChatPanel } from "components/ChatPanel/ChatPanel";
import { ChatToggleBtn } from "components/ChatToggleBtn/ChatToggleBtn";
import { useIsMobile } from "hooks/useIsMobile";

import grecoTriangleBg from "assets/GrECoGraphicTriangles.svg";

import AppContent from "./AppContent";
import AppMobileNavigation from "./AppMobileNavigation/AppMobileNavigation";
import { AppNavigation } from "./AppNavigation/AppNavigation";

export const AppLayout = ({ children }) => {
  const isMobile = useIsMobile();

  return (
    <Container>
      <Wrap>
        <DrawerWrap $flexDirection="column">
          <DrawerWrap
            style={{
              padding: "10px",
            }}
          >
            <AppNavigation />

            <AppContent>{children}</AppContent>
            <ChatPanel />
          </DrawerWrap>
          <AppMobileNavigation />
        </DrawerWrap>
        {isMobile ? null : <ChatToggleBtn />}
      </Wrap>
    </Container>
  );
};

const Container = styled("div")<{ $isPanelOpen?: boolean }>`
  position: absolute;
  overflow-y: hidden;
  top: ${sizes.appHeader}px; //70px header
  left: 0;
  bottom: ${sizes.appNavHeightMobile}px; //footer
  right: 0;
  width: 100%;
  background-color: ${(props) => props.theme.palette.themeBackground};

  background-image: url("${grecoTriangleBg}");
  background-size: auto;
  background-position-x: right;
  background-position-y: bottom;
  background-repeat: no-repeat;

  .fui-DrawerHeaderTitle__heading {
    width: 100%;
  }
  @media only screen and ${devices.md} {
    bottom: 5px; //no nav footer
  }
`;

const Wrap = styled.div`
  display: flex;
  width: 100%;
  margin: 10px auto 0;
  position: relative;

  @media only screen and ${devices.md} {
    width: 100%;
    max-width: ${sizes.appContentWidthDesktop}px;
  }
`;

const DrawerWrap = styled.div<{ $flexDirection?: string }>`
  display: flex;
  flex-direction: ${(props) => props.$flexDirection || "row"};
  display: flex;
  overflow-y: hidden;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 150px);
  padding-bottom: 20px;
  @media only screen and ${devices.md} {
    height: calc(100vh - 90px);
    padding-bottom: 0;
  }
`;
